import i18n from "i18n";
import AppConfig from "util/AppConfig";
import { archiveRetentionChanged, archiveRetentionShortenedBy } from "./archiveRetention";
import useIndexSetArchiveSettings from "./useIndexSetArchiveSettings";
const NS = "enterprise_archive";
const unknownMessage = (isLoading) => isLoading ? i18n.t("retention_confirmation.unknown_message_loading", { ns: NS }) : i18n.t("retention_confirmation.unknown_message_not_loaded", { ns: NS });
const shortenedMessage = (from, to) => from === null ? i18n.t("retention_confirmation.shortened_message_indefinite", { ns: NS, to }) : i18n.t("retention_confirmation.shortened_message", { ns: NS, from, to });
const useIndexSetSubmitConfirmation = ({ enabled = true } = {}) => {
  const applies = enabled && !AppConfig.isCloud();
  const { globalRetentionTime, isLoading } = useIndexSetArchiveSettings({ enabled: applies });
  return (initialValues, values) => {
    if (!applies) {
      return null;
    }
    if (globalRetentionTime === void 0) {
      if (!archiveRetentionChanged(initialValues, values)) {
        return null;
      }
      return {
        title: i18n.t("retention_confirmation.unknown_title", { ns: NS }),
        message: unknownMessage(isLoading)
      };
    }
    const shortened = archiveRetentionShortenedBy(initialValues, values, globalRetentionTime);
    if (!shortened) {
      return null;
    }
    return {
      title: i18n.t("retention_confirmation.shorten_title", { ns: NS }),
      message: shortenedMessage(shortened.from, shortened.to)
    };
  };
};
export default useIndexSetSubmitConfirmation;
